import React from "react";
import { twMerge } from "tailwind-merge";

interface VetraIconProps {
  width?: number;
  height?: number;
  className?: string;
  fill?: string;
}

export const VetraIcon: React.FC<VetraIconProps> = ({
  width = 23,
  height = 22,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 22"
      fill="none"
      className={twMerge(className, "text-primary-foreground")}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 8.75169C23 9.6137 22.2916 10.3125 21.4177 10.3125L20.457 10.3125C16.0876 10.3125 12.5455 6.8185 12.5455 2.50844L12.5455 1.56081C12.5455 0.698798 13.2539 1.13218e-07 14.1278 1.88577e-07L21.4177 8.17224e-07C22.2916 8.92583e-07 23 0.6988 23 1.56081L23 8.75169Z"
        fill="currentColor"
      />
      <path
        d="M14.1278 22C13.2539 22 12.5455 21.3012 12.5455 20.4392L12.5455 19.4916C12.5455 15.1815 16.0876 11.6875 20.457 11.6875L21.4177 11.6875C22.2916 11.6875 23 12.3863 23 13.2483L23 20.4392C23 21.3012 22.2916 22 21.4177 22L14.1278 22Z"
        fill="currentColor"
      />
      <path
        d="M0 13.2483C0 12.3863 0.708424 11.6875 1.58231 11.6875H2.543C6.91243 11.6875 10.4545 15.1815 10.4545 19.4916V20.4392C10.4545 21.3012 9.74612 22 8.87224 22H1.58231C0.708423 22 0 21.3012 0 20.4392L0 13.2483Z"
        fill="currentColor"
      />
      <path
        d="M8.87224 -6.82252e-08C9.74612 -3.05454e-08 10.4545 0.698799 10.4545 1.56081L10.4545 2.50845C10.4545 6.81851 6.91242 10.3125 2.543 10.3125L1.58231 10.3125C0.708423 10.3125 5.27658e-07 9.6137 5.65857e-07 8.75169L8.84509e-07 1.56081C9.22708e-07 0.698798 0.708425 -4.20228e-07 1.58231 -3.82548e-07L8.87224 -6.82252e-08Z"
        fill="currentColor"
      />
    </svg>
  );
};
